import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Mail, Tent } from "lucide-react";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState(null);

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    setStatus("loading");
    try {
      await api.emailAlert({ email });
      setStatus("ok");
      setEmail("");
    } catch {
      setStatus("err");
    }
  };

  return (
    <footer className="bg-ink text-white/85 mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <span className="w-9 h-9 rounded-lg bg-forest text-white flex items-center justify-center"><Tent className="w-5 h-5" /></span>
            <span className="font-display font-bold text-xl text-white">ParkScanner</span>
          </div>
          <p className="text-white/60 max-w-md leading-relaxed">
            Compare caravan holiday prices across every major UK operator in one place. No fluff, no logins — just real prices, real parks, real deals.
          </p>
          <form onSubmit={subscribe} className="mt-6 flex gap-2 max-w-md" data-testid="footer-email-form">
            <div className="flex-1 flex items-center bg-white/10 rounded-full px-4 border border-white/15">
              <Mail className="w-4 h-4 text-white/60 mr-2" />
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="your@email.com"
                className="flex-1 bg-transparent py-2.5 outline-none text-white placeholder:text-white/40 text-sm"
                data-testid="footer-email-input"
              />
            </div>
            <button className="btn-primary text-sm px-5 py-2" data-testid="footer-email-submit">
              {status === "loading" ? "..." : status === "ok" ? "Subscribed" : "Deal alerts"}
            </button>
          </form>
        </div>
        <div>
          <h4 className="font-display font-semibold text-white mb-3">Explore</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/search" className="hover:text-white">Search parks</Link></li>
            <li><Link to="/deals" className="hover:text-white">Best deals</Link></li>
            <li><Link to="/regions" className="hover:text-white">UK regions</Link></li>
            <li><Link to="/guides" className="hover:text-white">Guides &amp; collections</Link></li>
            <li><Link to="/collections/cheap-dog-friendly-caravans-cornwall" className="hover:text-white">Dog-friendly Cornwall</Link></li>
            <li><Link to="/collections/best-luxury-caravans-hot-tubs-devon" className="hover:text-white">Luxury Devon</Link></li>
            <li><Link to="/collections/affordable-last-minute-caravan-deals-uk" className="hover:text-white">Last-minute UK</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-display font-semibold text-white mb-3">Operators we cover</h4>
          <ul className="space-y-2 text-sm text-white/60">
            <li>Haven · Parkdean</li>
            <li>Away Resorts · Butlins</li>
            <li>Hoseasons · Pontins</li>
            <li>Park Holidays · & more</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-5 text-center text-xs text-white/40">
        © {new Date().getFullYear()} ParkScanner — independent comparison. We may earn an affiliate fee when you book. <a href="/admin/login" className="hover:text-white/70 ml-2" data-testid="footer-admin-link">Admin</a>
      </div>
    </footer>
  );
}
